import { cx } from '@linaria/core';
import { units } from '@ui/css';
import { tokens, ssrContainer } from './hide-for.style.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useMatchMedia } from '../hooks/match-media.js';

function HideFor(props) {
  const matches = useMatchMedia(props.breakpoint?.toQuery() ?? "", {
    immediate: props.immediate
  });
  if (!props.breakpoint) {
    return /*#__PURE__*/jsx(Fragment, {
      children: props.children
    });
  }
  switch (matches) {
    case true:
      return null;
    case false:
      return /*#__PURE__*/jsx("div", {
        "data-hide-for": false,
        className: props.className,
        children: props.children
      });
    default:
      return /*#__PURE__*/jsx("div", {
        "data-hide-for": true,
        className: cx(ssrContainer, props.className),
        style: tokens.__override({
          from: units.px(props.breakpoint.from ?? 0),
          to: units.px(props.breakpoint.to ?? 100000)
        }),
        children: props.children
      });
  }
}

export { HideFor };
//# sourceMappingURL=hide-for.js.map
